/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSdpUser = /* GraphQL */ `
  mutation CreateSdpUser(
    $input: CreateSdpUserInput!
    $condition: ModelSdpUserConditionInput
  ) {
    createSdpUser(input: $input, condition: $condition) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSdpUser = /* GraphQL */ `
  mutation UpdateSdpUser(
    $input: UpdateSdpUserInput!
    $condition: ModelSdpUserConditionInput
  ) {
    updateSdpUser(input: $input, condition: $condition) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSdpUser = /* GraphQL */ `
  mutation DeleteSdpUser(
    $input: DeleteSdpUserInput!
    $condition: ModelSdpUserConditionInput
  ) {
    deleteSdpUser(input: $input, condition: $condition) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSdpRecipe = /* GraphQL */ `
  mutation CreateSdpRecipe(
    $input: CreateSdpRecipeInput!
    $condition: ModelSdpRecipeConditionInput
  ) {
    createSdpRecipe(input: $input, condition: $condition) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSdpRecipe = /* GraphQL */ `
  mutation UpdateSdpRecipe(
    $input: UpdateSdpRecipeInput!
    $condition: ModelSdpRecipeConditionInput
  ) {
    updateSdpRecipe(input: $input, condition: $condition) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSdpRecipe = /* GraphQL */ `
  mutation DeleteSdpRecipe(
    $input: DeleteSdpRecipeInput!
    $condition: ModelSdpRecipeConditionInput
  ) {
    deleteSdpRecipe(input: $input, condition: $condition) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSdpRecipeInput = /* GraphQL */ `
  mutation CreateSdpRecipeInput(
    $input: CreateSdpRecipeInputInput!
    $condition: ModelSdpRecipeInputConditionInput
  ) {
    createSdpRecipeInput(input: $input, condition: $condition) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSdpRecipeInput = /* GraphQL */ `
  mutation UpdateSdpRecipeInput(
    $input: UpdateSdpRecipeInputInput!
    $condition: ModelSdpRecipeInputConditionInput
  ) {
    updateSdpRecipeInput(input: $input, condition: $condition) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSdpRecipeInput = /* GraphQL */ `
  mutation DeleteSdpRecipeInput(
    $input: DeleteSdpRecipeInputInput!
    $condition: ModelSdpRecipeInputConditionInput
  ) {
    deleteSdpRecipeInput(input: $input, condition: $condition) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLookupOption = /* GraphQL */ `
  mutation CreateLookupOption(
    $input: CreateLookupOptionInput!
    $condition: ModelLookupOptionConditionInput
  ) {
    createLookupOption(input: $input, condition: $condition) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLookupOption = /* GraphQL */ `
  mutation UpdateLookupOption(
    $input: UpdateLookupOptionInput!
    $condition: ModelLookupOptionConditionInput
  ) {
    updateLookupOption(input: $input, condition: $condition) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLookupOption = /* GraphQL */ `
  mutation DeleteLookupOption(
    $input: DeleteLookupOptionInput!
    $condition: ModelLookupOptionConditionInput
  ) {
    deleteLookupOption(input: $input, condition: $condition) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActionItems = /* GraphQL */ `
  mutation CreateActionItems(
    $input: CreateActionItemsInput!
    $condition: ModelActionItemsConditionInput
  ) {
    createActionItems(input: $input, condition: $condition) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateActionItems = /* GraphQL */ `
  mutation UpdateActionItems(
    $input: UpdateActionItemsInput!
    $condition: ModelActionItemsConditionInput
  ) {
    updateActionItems(input: $input, condition: $condition) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteActionItems = /* GraphQL */ `
  mutation DeleteActionItems(
    $input: DeleteActionItemsInput!
    $condition: ModelActionItemsConditionInput
  ) {
    deleteActionItems(input: $input, condition: $condition) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSdpCoolCloudData = /* GraphQL */ `
  mutation CreateSdpCoolCloudData(
    $input: CreateSdpCoolCloudDataInput!
    $condition: ModelSdpCoolCloudDataConditionInput
  ) {
    createSdpCoolCloudData(input: $input, condition: $condition) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const updateSdpCoolCloudData = /* GraphQL */ `
  mutation UpdateSdpCoolCloudData(
    $input: UpdateSdpCoolCloudDataInput!
    $condition: ModelSdpCoolCloudDataConditionInput
  ) {
    updateSdpCoolCloudData(input: $input, condition: $condition) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const deleteSdpCoolCloudData = /* GraphQL */ `
  mutation DeleteSdpCoolCloudData(
    $input: DeleteSdpCoolCloudDataInput!
    $condition: ModelSdpCoolCloudDataConditionInput
  ) {
    deleteSdpCoolCloudData(input: $input, condition: $condition) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const createSdpAmsData = /* GraphQL */ `
  mutation CreateSdpAmsData(
    $input: CreateSdpAmsDataInput!
    $condition: ModelSdpAmsDataConditionInput
  ) {
    createSdpAmsData(input: $input, condition: $condition) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSdpAmsData = /* GraphQL */ `
  mutation UpdateSdpAmsData(
    $input: UpdateSdpAmsDataInput!
    $condition: ModelSdpAmsDataConditionInput
  ) {
    updateSdpAmsData(input: $input, condition: $condition) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSdpAmsData = /* GraphQL */ `
  mutation DeleteSdpAmsData(
    $input: DeleteSdpAmsDataInput!
    $condition: ModelSdpAmsDataConditionInput
  ) {
    deleteSdpAmsData(input: $input, condition: $condition) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSdpAutoDeleteSchedule = /* GraphQL */ `
  mutation CreateSdpAutoDeleteSchedule(
    $input: CreateSdpAutoDeleteScheduleInput!
    $condition: ModelSdpAutoDeleteScheduleConditionInput
  ) {
    createSdpAutoDeleteSchedule(input: $input, condition: $condition) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSdpAutoDeleteSchedule = /* GraphQL */ `
  mutation UpdateSdpAutoDeleteSchedule(
    $input: UpdateSdpAutoDeleteScheduleInput!
    $condition: ModelSdpAutoDeleteScheduleConditionInput
  ) {
    updateSdpAutoDeleteSchedule(input: $input, condition: $condition) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSdpAutoDeleteSchedule = /* GraphQL */ `
  mutation DeleteSdpAutoDeleteSchedule(
    $input: DeleteSdpAutoDeleteScheduleInput!
    $condition: ModelSdpAutoDeleteScheduleConditionInput
  ) {
    deleteSdpAutoDeleteSchedule(input: $input, condition: $condition) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
